import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import useSubscription from "shared/services/subscriptions";
import { names } from "shared/services/subscriptions/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "utils/constants";

const CoverageBenefits = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) || INITIAL_VALUES.skip,
    take: parseInt(filter.take) || INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.COVERAGE_BENEFITS, {
    variables,
  });
  useSubscription({ query: names.COVERAGE_BENEFITS, variables });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "coverageBenefits",
      }}
    />
  );
};

CoverageBenefits.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

CoverageBenefits.defaultProps = {
  filter: {},
};

export default CoverageBenefits;
